module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10255.bd423724.jpg";